import { createActionsWithPrefix } from "../../helperfunctions/action";

export const SampleExamLogActions = createActionsWithPrefix("SAMPLEEXAMLOG/", {
    GET_SAMPLEEXAMLOG_REQUEST: "GET_SAMPLEEXAMLOG_REQUEST",
    GET_SAMPLEEXAMLOG_SUCCESS: "GET_SAMPLEEXAMLOG_SUCCESS",
    GET_SAMPLEEXAMLOG_ERROR: "GET_SAMPLEEXAMLOG_ERROR",
    EXPORT_SAMPLEEXAMLOG_REQUEST: "EXPORT_SAMPLEEXAMLOG_REQUEST",
    EXPORT_SAMPLEEXAMLOG_SUCCESS: "EXPORT_SAMPLEEXAMLOG_SUCCESS",
    EXPORT_SAMPLEEXAMLOG_FAILURE: "EXPORT_SAMPLEEXAMLOG_FAILURE"
});